import React from "react"
import styled from "styled-components"
// import LogoIcon from "../../../resources/img/logo-black.svg"
import LogoIcon from "../../../resources/img/logo-2025.svg"
import BlockContainer from "../BlockContainer"
import BurgerOpen from "../../../resources/img/ui/burger/burger-menu.svg"
import BurgerClose from "../../../resources/img/ui/burger/burger-close.svg"
import Search from "./icons/Search"
import BagLink from "./BagLink"
// import { Link } from "gatsby"
import Alink from "../Alink"
import breakpoints from "../../../styles/breakpoints"
// import { getIsFrance } from "../../../services/locale"
// import Account from "./icons/Account"

const HeaderContainer = styled.header`
  position: relative;

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const NavContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 0;
`

const List = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-end;
  height: 100%;
`

const Burger = styled.button`
  padding: 0;
  background: transparent;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border: none;
  cursor: pointer;
`

const SearchLink = styled(Alink)`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  svg {
    width: 13px;
    height: 13px;
  }
`

const LogoLink = styled(Alink)`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Logo = styled.img`
  width: 73px;
`

const BagContainer = styled.div`
  transform: translateX(6px);
  height: inherit;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-self: flex-end;
  gap: 16px;
`

// const AccountButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: transparent;
//   padding: 0;
//   border: none;
//   cursor: pointer;
// `

const MobileHeader = ({ cartOpen, setCartOpen, menuOpen, setMenuOpen }) => {
  // const isFrance = getIsFrance();

  let activeEnv = process.env.GATSBY_ACTIVE_ENV

  const availableEnvironments = ["eu", "uk", "fr", "us"]

  if (!availableEnvironments.includes(activeEnv)) {
    activeEnv = "us"
  }

  return (
    <HeaderContainer>
      <BlockContainer>
        <NavContent>
          <List>
            <Burger onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? (
                <img src={BurgerClose} alt="Close navigation" />
              ) : (
                <img src={BurgerOpen} alt="Open navigation" />
              )}
            </Burger>
            <SearchLink to={"/search"} aria-label="Search">
              <Search />
            </SearchLink>
          </List>
          <LogoLink to="/">
            <Logo src={LogoIcon} alt="Kimaï" />
          </LogoLink>
          <BagContainer>
            {/* {!isFrance && (
              <AccountButton onClick={() => handleAccountClick()}>
                <Account />
              </AccountButton>
            )} */}
            <BagLink cartOpen={cartOpen} setCartOpen={setCartOpen} />
          </BagContainer>
        </NavContent>
      </BlockContainer>
    </HeaderContainer>
  )
}

export default MobileHeader
